export default {
  CPD_AWARDS: (id) => `cpd_awards/awards?memberNo=${id}`,
  CPD_POINTS: (id) => `cpd_awards/points?memberNo=${id}`,
};
